(function () {
  var root = document.getElementById("wera-chat");
  if (!root || root.dataset.ready) return;
  root.dataset.ready = "1";

  var ENDPOINT = (root.dataset.endpoint || "").replace(/\/$/, "");
  var GREETING = root.dataset.greeting || "Hej! Vad kan jag hjälpa dig med?";
  var STORE_KEY = "wera-chat-v1";

  var $ = function (sel) { return root.querySelector(sel); };
  var launcher = $(".wc-launcher"), panel = $(".wc-panel"), closeBtn = $(".wc-close");
  var log = $(".wc-log"), suggest = $(".wc-suggest"), compose = $(".wc-compose");
  var input = $("#wc-input"), sendBtn = $(".wc-send"), humanBtn = $(".wc-human");
  var lead = $(".wc-lead"), leadError = $(".wc-lead-error"), leadSend = $(".wc-lead-send");
  var field = function (n) { return lead.elements.namedItem(n); };

  var state = load() || { open: false, messages: [], leadSent: false };
  var busy = false;

  function load() { try { return JSON.parse(sessionStorage.getItem(STORE_KEY)); } catch (e) { return null; } }
  function save() { try { sessionStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) {} }

  /* ---------- rendering ---------- */
  function escapeHtml(s) {
    return s.replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function linkify(text) {
    var html = escapeHtml(text.replace(/\*\*(.+?)\*\*/g, "$1"));
    html = html.replace(/\b(https?:\/\/[^\s<]+[^\s<.,;:!?)])/g, '<a href="$1" target="_blank" rel="noopener">$1</a>');
    html = html.replace(/(^|[\s(])((?:www\.)?weratents\.se(?:\/[^\s<]*[^\s<.,;:!?)])?)/g, function (m, pre, url) {
      return pre + '<a href="https://' + url.replace(/^www\./, "") + '">' + url + "</a>";
    });
    html = html.replace(/(^|[\s(])([\w.+-]+@[\w-]+\.[\w.]*[a-z])/gi, '$1<a href="mailto:$2">$2</a>');
    return html;
  }
  function addBubble(role, text) {
    var p = document.createElement("p");
    p.className = "wc-msg wc-msg--" + (role === "user" ? "user" : "bot");
    p.innerHTML = linkify(text);
    log.appendChild(p);
    log.scrollTop = log.scrollHeight;
    return p;
  }
  function renderAll() {
    lead.remove();
    log.innerHTML = "";
    addBubble("assistant", GREETING);
    state.messages.forEach(function (m) { addBubble(m.role, m.content); });
    suggest.hidden = state.messages.length > 0;
  }
  function showTyping() {
    var t = document.createElement("div");
    t.className = "wc-msg wc-msg--bot wc-typing";
    t.setAttribute("aria-label", "Skriver…");
    t.innerHTML = "<span></span><span></span><span></span>";
    log.appendChild(t);
    log.scrollTop = log.scrollHeight;
    return t;
  }

  /* ---------- open / close ---------- */
  function setOpen(open) {
    state.open = open;
    save();
    panel.hidden = !open;
    launcher.setAttribute("aria-expanded", String(open));
    if (open) {
      log.scrollTop = log.scrollHeight;
      if (window.matchMedia("(min-width: 601px)").matches) input.focus();
    } else {
      launcher.focus();
    }
  }
  launcher.addEventListener("click", function () { setOpen(true); });
  closeBtn.addEventListener("click", function () { setOpen(false); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !panel.hidden) setOpen(false); });

  /* ---------- chat ---------- */
  function send(text) {
    text = (text || "").trim();
    if (!text || busy) return;
    busy = true;
    sendBtn.disabled = true;
    suggest.hidden = true;
    state.messages.push({ role: "user", content: text });
    save();
    addBubble("user", text);
    input.value = "";
    autosize();
    var typing = showTyping();

    fetch(ENDPOINT + "/chat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ messages: state.messages.slice(-12) })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        typing.remove();
        var reply = (data && data.reply) || "Jag kunde inte svara just nu. Lämna gärna dina uppgifter så hör vi av oss.";
        state.messages.push({ role: "assistant", content: reply });
        save();
        addBubble("assistant", reply);
        if (data && data.handoff && !state.leadSent) openLead(text);
      })
      .catch(function () {
        typing.remove();
        addBubble("assistant", "Anslutningen bröts. Försök igen, eller mejla oss på info@weratents.se.");
        state.messages.pop();
        save();
      })
      .finally(function () { busy = false; sendBtn.disabled = false; });
  }

  compose.addEventListener("submit", function (e) { e.preventDefault(); send(input.value); });
  input.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(input.value); }
  });
  function autosize() {
    input.style.height = "auto";
    input.style.height = Math.min(input.scrollHeight, 120) + "px";
  }
  input.addEventListener("input", autosize);
  root.querySelectorAll(".wc-chip").forEach(function (chip) {
    chip.addEventListener("click", function () { send(chip.textContent); });
  });

  /* ---------- lead form (shown inside the conversation) ---------- */
  function openLead(prefill) {
    log.appendChild(lead);
    lead.hidden = false;
    compose.hidden = true;
    humanBtn.hidden = true;
    leadError.hidden = true;
    if (prefill && !field("message").value) field("message").value = prefill;
    setTimeout(function () {
      var prev = lead.previousElementSibling;
      log.scrollTop = prev ? prev.offsetTop - 12 : log.scrollHeight;
      field("name").focus({ preventScroll: true });
    }, 50);
  }
  function closeLead() {
    lead.hidden = true;
    compose.hidden = false;
    humanBtn.hidden = state.leadSent;
  }
  humanBtn.addEventListener("click", function () {
    var lastUser = state.messages.filter(function (m) { return m.role === "user"; }).pop();
    openLead(lastUser ? lastUser.content : "");
  });
  $(".wc-lead-cancel").addEventListener("click", closeLead);

  lead.addEventListener("submit", function (e) {
    e.preventDefault();
    var payload = {
      name: field("name").value.trim(),
      email: field("email").value.trim(),
      phone: field("phone").value.trim(),
      message: field("message").value.trim(),
      consent: field("consent").checked,
      page: location.href,
      transcript: state.messages.map(function (m) {
        return (m.role === "user" ? "Kund: " : "Bot: ") + m.content;
      }).join("\n")
    };
    var err = "";
    if (!payload.name) err = "Fyll i ditt namn.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.email)) err = "Fyll i en giltig e-postadress.";
    else if (!payload.consent) err = "Kryssa i rutan så att vi får spara dina uppgifter.";
    if (err) { leadError.textContent = err; leadError.hidden = false; return; }

    leadSend.disabled = true;
    leadSend.textContent = "Skickar…";
    fetch(ENDPOINT + "/lead", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.ok) throw new Error((data && data.error) || "");
        state.leadSent = true;
        save();
        lead.reset();
        closeLead();
        addBubble("assistant", "Tack " + payload.name.split(" ")[0] + "! Vi har fått dina uppgifter och hör av oss så snart vi kan.");
      })
      .catch(function (e) {
        leadError.textContent = e.message || "Det gick inte att skicka. Mejla oss gärna på info@weratents.se.";
        leadError.hidden = false;
      })
      .finally(function () { leadSend.disabled = false; leadSend.textContent = "Skicka"; });
  });

  /* ---------- init ---------- */
  renderAll();
  humanBtn.hidden = state.leadSent;
  if (state.open) { panel.hidden = false; launcher.setAttribute("aria-expanded", "true"); }
})();